/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import theme from '@salesforce/retail-react-app/app/components/shared/theme'

export default {
    baseStyle: {
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'background.base.default',
            minWidth: '320px',
            minHeight: '100vh',
            textColor: 'foreground.neutral.default',
        },
        headerWrapper: {
            position: 'sticky',
            // Offset by the sales-assistant banner height when present so the
            // navbar pins right below it (the var defaults to 0px otherwise).
            top: 'var(--sa-banner-height, 0px)',
            zIndex: theme.zIndices.sticky,
        },
        blackbar: {
            width: '100% !important',
            backgroundColor: 'rgba(0, 0, 0, 0.5) !important',
            position: 'fixed',
            top: 0,
            display: 'block',
            height: '100%',
            zIndex: 999997,
        },
    },
    parts: ['container'],
}
